<template>
  <span>
    <span v-if="nonAnsweredNames.length > 0"><font-awesome-icon icon="clock" /> {{nonAnsweredNames}}</span>
  </span>
</template>

<script>
import Vue from "vue";

export default {
  props: ["survey"],
  data: function () {
    return {};
  },
  computed: {
    nonAnsweredNames() {
      let count = 0;
      let string = "";
      this.$store.getters.getPlayers.forEach((player) => {
        const answer = this.$store.getters.getSurveyAnswersByCaseNumberSurveyNumberPlayerId(
          this.$store.getters.getCurrentCaseNumber,
          this.survey,
          player.id
        );
        if (!answer.length && !player.paused) {
          // Player has not yet answered
          if (count > 0) {
            // Add comma if more than one player
            string += ", "
          }
          string += player.nick_name;
          count++;
        }
      });

      return string;
    },
  },
};
</script>
